var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.6581,
    fill: "white",
    stroke: "#EBF4FF",
    strokeWidth: 0.683761
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.341,
    cy: 40.3429,
    r: 28.7179,
    fill: "#FFC107"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1379 45.16C37.8501 45.16 37.6147 45.0667 37.4316 44.88C37.2485 44.6667 37.1569 44.4267 37.1569 44.16V27C37.1569 26.7067 37.2485 26.4667 37.4316 26.28C37.6147 26.0933 37.8501 26 38.1379 26H42.65C42.9378 26 43.1732 26.0933 43.3563 26.28C43.5394 26.4667 43.6309 26.7067 43.6309 27V44.16C43.6309 44.4267 43.5394 44.6667 43.3563 44.88C43.1732 45.0667 42.9378 45.16 42.65 45.16H38.1379ZM37.9809 54C37.6932 54 37.4578 53.9067 37.2747 53.72C37.0916 53.5067 37 53.2667 37 53V48.08C37 47.7867 37.0916 47.5467 37.2747 47.36C37.4578 47.1467 37.6932 47.04 37.9809 47.04H42.807C43.0685 47.04 43.2909 47.1467 43.474 47.36C43.6832 47.5467 43.7879 47.7867 43.7879 48.08V53C43.7879 53.2667 43.6832 53.5067 43.474 53.72C43.2909 53.9067 43.0685 54 42.807 54H37.9809Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.6d2a72f1c79d8b1d4665992578f2abda.svg";
export { ForwardRef as ReactComponent };